export default function isBoolean(value) {
  return value === 'true' || value === 'false' || typeof value === 'boolean';
}

export function parseBoolean(value) {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return value;
}
